import { createAsyncThunk, createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'Douleutaras/redux/store';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { Category } from 'Douleutaras/types/category';
import { makeRequest } from 'Douleutaras/services/apiClient';

const categoriesTosAdapter = createEntityAdapter<JSONApiDataObject<{}>>();

export const getCategoryTos = createAsyncThunk(
  'categories/tos',
  async ({ categoryId }: { categoryId: string }, api) => {
    const response = await makeRequest(`api/public/category_form/${categoryId}/tos/`, {
      method: 'GET'
    })(api);

    return response.data;
  }
);

export const categoriesTosSlice = createSlice({
  name: 'categoriesTos',
  initialState: '',
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getCategoryTos.fulfilled, (state, action) => {
      return action.payload;
    });
  }
});

export const categoriesTosSelector = categoriesTosAdapter.getSelectors((state: RootState) => state.categoriesTos);
